<template>
    <v-dialog v-model="openMode" max-width="520px" content-class="cm-dialog" overlay-color="#0d2c6d"
        overlay-opacity="0.55" transition="dialog-bottom-transition">
        <v-card class="cm-dlg-card">

            <!-- ───────── HEADER ───────── -->
            <div class="cm-dlg-head">
                <div class="cm-dlg-head__main">
                    <div class="cm-dlg-head__icon" aria-hidden="true">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="7" r="3" />
                            <circle cx="5" cy="17" r="3" />
                            <circle cx="19" cy="17" r="3" />
                            <path d="M10.5 9.5 7 14.5" />
                            <path d="m13.5 9.5 3.5 5" />
                        </svg>
                    </div>
                    <div>
                        <span class="cm-dlg-eyebrow">שיוך קהילתי</span>
                        <h2 class="cm-dlg-title">עדכון קהילה</h2>
                    </div>
                </div>
                <button type="button" class="cm-dlg-close" @click="openMode = false" aria-label="סגור">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                        stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
            </div>

            <!-- ───────── BODY ───────── -->
            <v-card-text class="cm-dlg-body">

                <!-- Current customer chip -->
                <div v-if="itemToEdit && (itemToEdit.name || itemToEdit.family)" class="cm-customer-chip">
                    <span class="cm-customer-chip__label">לקוח</span>
                    <span class="cm-customer-chip__name">
                        {{ [itemToEdit.name, itemToEdit.family].filter(Boolean).join(' ') }}
                    </span>
                </div>

                <v-form @submit.prevent="submitHandler" ref="form">
                    <label class="cm-field-label">בחר קהילה חדשה</label>
                    <v-select :items="communities" :item-text="'name'" :item-value="'_id'" return-object outlined dense
                        v-model="itemEdited.community_id" required :rules="[(v) => !!v || 'שדה חובה']"
                        prepend-inner-icon="mdi-account-group-outline" placeholder="בחר מתוך הרשימה"
                        :menu-props="{ contentClass: 'cm-select-menu' }"></v-select>
                </v-form>
            </v-card-text>

            <!-- ───────── FOOTER ───────── -->
            <div class="cm-dlg-foot">
                <v-progress-linear v-if="overlay" indeterminate color="#0d2c6d" height="2" />
                <div class="cm-dlg-foot__actions">
                    <button type="button" class="cm-dlg-btn cm-dlg-btn--ghost" @click="openMode = false"
                        :disabled="overlay">ביטול</button>
                    <button type="button" class="cm-dlg-btn cm-dlg-btn--primary" @click="updateCommunity()"
                        :disabled="overlay">
                        <svg v-if="!overlay" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M20 6 9 17l-5-5"></path>
                        </svg>
                        <span>{{ overlay ? 'מעדכן...' : 'עדכן קהילה' }}</span>
                    </button>
                </div>
            </div>

        </v-card>

        <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
    </v-dialog>
</template>

<script>
import SnackBar from '@/components/widgets/snackBar.vue'
import ApiServices from '@/services/api.service'
import SharedFunctions from "@/shared/SharedFunctions";

export default {
    props: {
        itemToEdit: Object,
        value: { type: Boolean, default: false },
    },
    components: {
        SnackBar,
    },
    data: () => ({
        overlay: false,
        snackbar: false,
        snackbarColorBt: "green",
        snacbarText: "",
        itemEdited: {
            _id: "",
            community_id: "",
        },
        communities: []
    }),
    methods: {
        async updateCommunity() {
            // guard: form must be valid (chosen community)
            if (!this.$refs.form.validate()) return;

            const myJSON = JSON.stringify({
                community_id: this.itemEdited.community_id._id,
                customerId: this.itemToEdit._id,
            });
            this.overlay = true;
            let token = localStorage.getItem("token");
            try {
                let api = process.env.VUE_APP_BASE_URL + "/customers/edit_community";
                const res = await fetch(api, ApiServices.requestOptions("PUT", myJSON, token));
                const jsonObject = await res.json();
                this.overlay = false; // ── fixed: was `this.progresoverlaysShow = false` (typo, no-op)
                if (res.status >= 400) {
                    this.showSnackBar("Error: " + jsonObject, "red");
                } else if (res.status === 200) {
                    this.$emit("itemEdited", this.itemEdited, "הקהילה עודכנה בהצלחה", "green");
                    this.openMode = false;
                }
            } catch (error) {
                this.overlay = false;
                this.showSnackBar("Error saved edited community: " + error, "red");
            }
        },
        async getCommunities() {
            this.overlay = true;
            this.communities = await SharedFunctions.getCommunities();
            this.overlay = false;
        },
        showSnackBar(message, color) {
            this.snacbarText = message;
            this.snackbarColorBt = color;
            this.snackbar = true
        }
    },
    computed: {
        openMode: {
            get() {
                return this.value
            },
            set(v) {
                return this.$emit('input', v)
            }
        },
    },
    mounted() {
        this.itemEdited = JSON.parse(JSON.stringify(this.itemToEdit));
        this.getCommunities();
    },
}
</script>

<style scoped>
.cm-dialog {
    border-radius: 20px !important;
    overflow: hidden;
}

.cm-dlg-card {
    --c-navy: #0d2c6d;
    --c-purple: #8066f0;
    --c-border-soft: #eef2f7;
    --c-text: #0f172a;
    --c-text-soft: #475569;
    --c-text-mute: #94a3b8;
    font-family: 'Assistant', 'Heebo', system-ui, sans-serif;
    direction: rtl;
    background: #ffffff !important;
    border-radius: 20px !important;
    overflow: hidden;
}

/* ─── HEADER ─── */
.cm-dlg-head {
    background:
        radial-gradient(600px 180px at 90% -40%, rgba(128, 102, 240, 0.18), transparent 60%),
        linear-gradient(135deg, #0d2c6d 0%, #142f78 55%, #1a3a8a 100%);
    color: #fff;
    padding: 18px 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
}

.cm-dlg-head__main {
    display: flex;
    align-items: center;
    gap: 13px;
}

.cm-dlg-head__icon {
    width: 40px;
    height: 40px;
    border-radius: 11px;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.22);
    display: grid;
    place-items: center;
}

.cm-dlg-eyebrow {
    display: block;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.65);
}

.cm-dlg-title {
    margin: 1px 0 0;
    font-size: 1.1rem;
    font-weight: 800;
    color: #fff;
}

.cm-dlg-close {
    width: 32px;
    height: 32px;
    border-radius: 9px;
    background: rgba(255, 255, 255, 0.10);
    border: 1px solid rgba(255, 255, 255, 0.18);
    color: #fff;
    cursor: pointer;
    display: grid;
    place-items: center;
    transition: background 0.2s, transform 0.2s;
}

.cm-dlg-close:hover {
    background: rgba(255, 255, 255, 0.18);
    transform: rotate(90deg);
}

/* ─── BODY ─── */
.cm-dlg-body {
    padding: 22px 24px 12px !important;
    background: #fbfcfe;
}

.cm-customer-chip {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 8px 14px 8px 16px;
    border-radius: 999px;
    background: rgba(13, 44, 109, 0.06);
    border: 1px solid rgba(13, 44, 109, 0.10);
    margin-bottom: 18px;
}

.cm-customer-chip__label {
    font-size: 0.7rem;
    font-weight: 700;
    color: var(--c-text-mute);
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.cm-customer-chip__name {
    font-size: 0.92rem;
    font-weight: 700;
    color: var(--c-navy);
}

.cm-field-label {
    display: block;
    font-size: 0.82rem;
    font-weight: 700;
    color: var(--c-text-soft);
    margin-bottom: 8px;
}

::v-deep .v-text-field--outlined fieldset,
::v-deep .v-select--outlined fieldset {
    border-color: #e3e8ef !important;
    transition: border-color 0.2s, box-shadow 0.2s;
}

::v-deep .v-text-field--outlined:hover fieldset,
::v-deep .v-select--outlined:hover fieldset {
    border-color: #c7d2e0 !important;
}

::v-deep .v-input--is-focused fieldset {
    border-color: var(--c-navy) !important;
    border-width: 2px !important;
    box-shadow: 0 0 0 4px rgba(13, 44, 109, 0.06);
}

::v-deep .v-input__prepend-inner {
    margin-top: 9px !important;
}

::v-deep .v-input__prepend-inner .v-icon {
    color: var(--c-text-mute) !important;
}

::v-deep .v-input--is-focused .v-input__prepend-inner .v-icon {
    color: var(--c-navy) !important;
}

/* ─── FOOTER ─── */
.cm-dlg-foot {
    background: #ffffff;
    border-top: 1px solid var(--c-border-soft);
}

.cm-dlg-foot__actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 14px 22px;
}

.cm-dlg-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 9px 22px;
    border-radius: 10px;
    border: none;
    font-family: inherit;
    font-weight: 700;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.cm-dlg-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.cm-dlg-btn--ghost {
    background: transparent;
    color: var(--c-text-soft);
    border: 1px solid #e3e8ef;
}

.cm-dlg-btn--ghost:hover:not(:disabled) {
    background: #f8fafc;
    color: var(--c-text);
}

.cm-dlg-btn--primary {
    background: linear-gradient(135deg, var(--c-navy) 0%, #142f78 100%);
    color: #fff;
    box-shadow: 0 6px 14px -4px rgba(13, 44, 109, 0.45);
}

.cm-dlg-btn--primary:hover:not(:disabled) {
    transform: translateY(-1px);
    filter: brightness(1.08);
}
</style>